/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum LibraryCategory {
    JOURNAL_ARTICLES = 'JournalArticles',
    DRUG_LIBRARY = 'DrugLibrary',
    ABSTRACTS_AND_INSIGHTS = 'AbstractsAndInsights',
    GUIDANCE_AND_PROTOCOLS = 'GuidanceAndProtocols',
    PRACTICE_UPDATES = 'PracticeUpdates',
    PRACTICAL_TOOLS = 'PracticalTools',
    ACADEMIC_EVENTS = 'AcademicEvents',
    SOCIAL_CONTENT = 'SocialContent',
    TIPS_AND_TUTORIALS = 'TipsAndTutorials',
}
